import React from 'react';

type Props = {
  urlLink: string | null;
};

const MediaBackground = ({ urlLink }: Props) => {
  return (
    <>
      {urlLink && (
        <video
          playsInline
          autoPlay
          loop
          muted
          id="background-media"
          style={{
            minWidth: '100%',
            minHeight: '100%',
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            top: '50%',
            left: 0,
            right: 0,
            transform: ' translateY(-50%)',
            position: 'absolute',
          }}
        >
          <source src={urlLink} type="video/mp4" />
        </video>
      )}
    </>
  );
};

export default MediaBackground;
